module.exports = __webpack_public_path__ + "static/media/professor.00772159.pdf";